module.exports = __webpack_public_path__ + "06_short_gold.4d030cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_short_gold.png
// module id = uj+i
// module chunks = 0